import { useCallback, useRef, useState, RefObject, useEffect } from 'react'

export function useHoverOrigin<T extends HTMLElement>(containerRef?: RefObject<HTMLElement>) {
  const ref = useRef<T>(null)
  const [origin, setOrigin] = useState<'left' | 'right'>('right')

  const recompute = useCallback(() => {
    if (!containerRef?.current || !ref.current) return
    const cardRect = ref.current.getBoundingClientRect()
    const contRect = containerRef.current.getBoundingClientRect()
    const cardCenterX = cardRect.left + cardRect.width / 2
    const contCenterX = contRect.left + contRect.width / 2

    setOrigin(cardCenterX > contCenterX ? 'left' : 'right')
  }, [containerRef])

  useEffect(() => {
    const cardEl = ref.current
    if (!cardEl) return
    recompute()

    cardEl.addEventListener('recomputeOrigin', recompute)
    return () => {
      cardEl.removeEventListener('recomputeOrigin', recompute)
    }
  }, [recompute])

  return { ref, origin }
}
